import { CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  let isAuthenticated: boolean;
  let sessionJSON = localStorage.getItem('eagleSession');
  let session = sessionJSON ? JSON.parse(sessionJSON) : null;

  if (!session || (new Date(Number(session['expires'])) < new Date())) {
    isAuthenticated = false;
    window.location.href = route.data['externalLogin'];
    return false;
  }

  return true;
};


export const notAuthedGuard: CanActivateFn = (route, state) => {
  let sessionJSON = localStorage.getItem('eagleSession');
  let session = sessionJSON ? JSON.parse(sessionJSON) : null;

  if (session && (new Date(Number(session['expires'])) >= new Date()))
    return false;

  return true;
};

export const isAuthedEaglebeUser: CanActivateFn = (route, state) => {
  let isAuthenticated: boolean;
  let sessionJSON = localStorage.getItem('eagleSession');
  let session = sessionJSON ? JSON.parse(sessionJSON) : null;

  if (!session || (new Date(Number(session['expires'])) < new Date())) {
    localStorage.removeItem('eagleSession');
    localStorage.removeItem('loginDetails');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');

    sessionStorage.clear();
  }

  return true;
};